import styled from 'styled-components';

export const Selected = styled.span`
  background: #b9f5ff; // TODO цвет
`;
